












































import Button from '@/types/components/Button.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    props: {
        //  Determines if the 'add' button is displayed
        add: {
            type: Boolean,
            default: false
        },
        //  Replaces the 'add' tooltip
        addTooltip: {
            type: String,
            default: null
        },
        //  List of buttons displayed to the left of the edit button
        buttons: {
            type: Array as PropType<Button[]>,
            default: null
        },
        //  The color applied to the text
        color: {
            type: String,
            default: 'grey darken-2'
        },
        //  Determines if a divider is shown under the title
        divider: {
            type: Boolean,
            default: true
        },
        //  Determines if the 'edit' button is visible
        edit: {
            type: Boolean,
            default: false
        },
        //  The icon shown to the left of the title
        icon: {
            type: String,
            default: null
        },
        //  The text displayed to the left of the edit button
        info: {
            type: String,
            default: null
        },
        //  The title displayed on the component
        title: {
            type: String,
            default: 'Title Placeholder'
        },
        //  The type of entity being added
        type: {
            type: String,
            default: ''
        }
    },
    methods: {
        onAdd(): void {
            this.$emit('add')
        },
        onEdit(): void {
            this.$emit('open')
        }
    },
    computed: {
        //  Converts the current vuetify color class into vuetify text--color class
        titleClass(): string {
            //  Get the vuetify color class
            const color = this.$options.filters.colorToText(this.color)

            //  Else, return default style
            return `subtitle-1 ${color}`
        }
    }
})
